import React from 'react';
import {Text, View} from 'react-native';

const CartProductCard: React.FC = () => {
  return (
    <View>
      <Text>CartProductCard</Text>
    </View>
  );
};

export default CartProductCard;
